import { Box, Grid } from "@material-ui/core";
import React from "react";
import { AddItemInputFields } from "./AddItemInputFields";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function AddItemInput({}: Props): React.ReactElement {
  return (
    <>
      <Box borderColor="grey.200">
        <Grid container direction="row">
          <Grid item xs={12} md={12}>
            {/* Conent Start */}
            <AddItemInputFields />
            {/* Conent End */}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
